<template>
    <v-card-text>
        <div class="px-4 pt-4 d-flex align-start" style="gap: 4px">
            <p class="mb-0 font-16" style="flex: 1">{{ label }}</p>
            <v-dialog v-model="dialog" width="500">
                <template v-slot:activator="{ on, attrs }">
                    <v-btn icon color="primary" class="mt-n1 flex-shrink-0" v-bind="attrs" v-on="on">
                        <v-icon>fa fa-circle-info</v-icon>
                    </v-btn>
                </template>
                <v-card v-if="typeof image_url === 'string'">
                    <v-img :src="image_url"></v-img>
                </v-card>

                <v-slide-group v-else class="pa-4" center-active show-arrows>
                  <v-slide-item v-for="url in image_url" :key="url">
                    <v-card class="ma-4" height="400" width="300" outlined>
                      <v-row class="fill-height" align="center" justify="center">
                        <v-scale-transition>
                          <v-img :src="url" />
                        </v-scale-transition>
                      </v-row>
                    </v-card>
                  </v-slide-item>
                </v-slide-group>
            </v-dialog>
        </div>
    </v-card-text>
</template>

<script>
export default {
    name: "VTextWithButton",
    props: {
        label: {
            type: String,
            required: true,
        },
        image_url: {
            type: String || Array,
            required: false,
        },
    },
    data() {
        return {
            dialog: false,
        };
    },
};
</script>

<style scoped>
.w_90p {
    width: 90%;
}
</style>
